var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FacialRecognition50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M5,28h38v14H5V28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b8d4",
    d: "M14 40L7 40 7 33 9 33 9 38 14 38zM41 40L34 40 34 38 39 38 39 33 41 33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M41 13L39 13 39 8 34 8 34 6 41 6zM9 13L7 13 7 6 14 6 14 8 9 8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M35 26c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2S35 24.9 35 26M17 26c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2S17 24.9 17 26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M33,20c0-7.6-18-5-18,0v7c0,5,4,9,9,9s9-4,9-9V20z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M24,11c-6.1,0-10,4.9-10,11v2.3l2,1.7v-5l12-4l4,4v5l2-1.7V22c0-4-1-8-6-9l-1-2H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M27 26c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1S27 25.4 27 26M19 26c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1S19 25.4 19 26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e5ff",
    d: "M15.1,28c0.5,4.5,4.3,8,8.9,8s8.4-3.5,8.9-8H15.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#18ffff",
    d: "M5,28h38v2H5V28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FacialRecognition50);
export default __webpack_public_path__ + "static/media/icons8-facial-recognition-50.aaf915d9f95abcbc7d4245bb4aaa6353.svg";
export { ForwardRef as ReactComponent };